import gql from 'graphql-tag';

export const costOffsetCodeListQuery = gql(/* GraphQL */ `
  query listCostOffsetCode(
    $listCostOffsetCodeRequest: ListCostOffsetCodeRequest!
  ) {
    accounts {
      listCostOffsetCode(
        listCostOffsetCodeRequest: $listCostOffsetCodeRequest
      ) {
        costOffsetCodes {
          id
          code
          description
          groupId
          groupType
        }
        pageInfo {
          perPage
          start
          total
        }
      }
    }
  }
`);
